// extracted by mini-css-extract-plugin
export default {"item":"TableProductItem_item__81bon","bodyColumn":"TableProductItem_bodyColumn__L0AIs","imageLimit":"TableProductItem_imageLimit__HmAuN","img":"TableProductItem_img__yHgIa"};